import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from '../loader.service';
import { LoaderState, AILoaderState } from '../loader-state';
import { Location } from '@angular/common';
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  loading = false;
  aiLoader = false;
  signaturePage = false;
  private subscription: Subscription;
  constructor(private loaderService: LoaderService, private location: Location) { }
  ngOnInit() {
    
    const currentUrl = this.location.path();
   // this.signaturePage = currentUrl.includes("esignature");

    this.subscription = this.loaderService.loaderState
      .subscribe((state: LoaderState) => {
        this.loading = state.show;
      });

      this.subscription = this.loaderService.aiLoaderState
      .subscribe((state: AILoaderState) => {
        this.aiLoader = state.showAI;
      });

  }
}
